import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addRule: {
		id: 'servicedesk.automation.summary.empty-view.add-a-rule',
		defaultMessage: 'Add a rule',
		description: '',
	},
	description: {
		id: 'servicedesk.automation.summary.empty-view.description',
		defaultMessage: "Streamline your team's work with Automation.",
		description: '',
	},
	learnMore: {
		id: 'servicedesk.automation.summary.empty-view.learn-more',
		defaultMessage: 'Learn more',
		description: '',
	},
});
